export default __webpack_public_path__ + "static/media/1.b5c66fe6.jpg";